/**
 * @author LB
 * @description 运营路由
 */
export default [
  /***********调研任务************/
  {
    path: '/operation/surveyTask/taskList',
    name: 'operation_taskList',
    meta: {
      title: '任务列表',
      pageId: 'taskList',
      pageName: '任务列表',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/taskList'], resolve),
  },
  {
    path: '/operation/surveyTask/difficultTask',
    name: 'operation_difficultTask',
    meta: {
      title: '困难任务',
      pageId: 'difficultTask',
      pageName: '困难任务',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/difficultTask'], resolve),
  },
  {
    path: '/operation/surveyTask/taskProgress',
    name: 'operation_taskProgress',
    meta: {
      title: '任务进度',
      pageId: 'taskProgress',
      pageName: '任务进度',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/taskProgress'], resolve),
  },
  {
    path: '/operation/surveyTask/taskSignature',
    name: 'operation_taskSignature',
    meta: {
      title: '任务补签',
      pageId: 'taskSignature',
      pageName: '任务补签',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/taskSignature'], resolve),
  },
  {
    path: '/operation/surveyTask/taskAppeal',
    name: 'operation_taskAppeal',
    meta: {
      title: '任务申诉',
      pageId: 'taskAppeal',
      pageName: '任务申诉',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/taskAppeal'], resolve),
  },
  {
    path: '/operation/surveyTask/customerResearchTask',
    name: 'operation_customerResearchTask',
    meta: {
      title: '客群调研',
      pageId: 'customerResearchTask',
      pageName: '客群调研',
      parentId: 'surveyTask',
      parentName: '调研任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/surveyTask/customerResearchTask'], resolve),
  },
  /***********报告管理************/
  {
    path: '/operation/reportManage/reportAudit',
    name: 'operation_reportAudit',
    meta: {
      title: '报告审核',
      pageId: 'reportAudit',
      pageName: '报告审核',
      parentId: 'reportManage',
      parentName: '报告管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/reportManage/reportAudit'], resolve),
  },
  {
    path: '/operation/reportManage/reportDelivery',
    name: 'operation_reportDelivery',
    meta: {
      title: '报告交付',
      pageId: 'reportDelivery',
      pageName: '报告交付',
      parentId: 'reportManage',
      parentName: '报告管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/reportManage/reportDelivery'], resolve),
  },
  {
    path: '/operation/reportManage/reportAppeal',
    name: 'operation_reportAppeal',
    meta: {
      title: '报告申诉',
      pageId: 'reportAppeal',
      pageName: '报告申诉',
      parentId: 'reportManage',
      parentName: '报告管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/reportManage/reportAppeal'], resolve),
  },
  /***********支付管理************/
  {
    path: '/operation/paymentManage/remunerationPayment',
    name: 'operation_remunerationPayment',
    meta: {
      title: '酬劳结算',
      pageId: 'remunerationPayment',
      pageName: '酬劳结算',
      parentId: 'paymentManage',
      parentName: '支付管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/paymentManage/remunerationPayment'], resolve),
  },
  // {
  //   path: '/operation/paymentManage/billPayment',
  //   name: 'operation_billPayment',
  //   meta: {
  //     title: '单据支付',
  //     pageId: 'billPayment',
  //     pageName: '单据支付',
  //     parentId: 'paymentManage',
  //     parentName: '支付管理',
  //     pageLayer: 3,
  //   },
  //   component: resolve => require(['@/views/operation/paymentManage/billPayment'], resolve),
  // },
  {
    path: '/operation/paymentManage/withdrawal',
    name: 'operation_withdrawal',
    meta: {
      title: '提现管理',
      pageId: 'withdrawal',
      pageName: '提现管理',
      parentId: 'paymentManage',
      parentName: '支付管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/paymentManage/withdrawal'], resolve),
  },
  /***********模板管理************/
  {
    path: '/operation/templateManage',
    name: 'operation_templateManage',
    meta: {
      title: '模板管理',
      pageId: 'templateManage',
      pageName: '模板管理',
      parentId: 'operation',
      parentName: '暗访',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/operation/templateManage/templateManage'], resolve),
  },
  /***********商务管理************/
  {
    path: '/operation/businessManage/billList',
    name: 'operation_billList',
    meta: {
      title: '账单列表',
      pageId: 'billList',
      pageName: '账单列表',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/billList'], resolve),
  },
  {
    path: '/operation/businessManage/actualBillList',
    name: 'operation_actualBillList',
    meta: {
      title: '收入列表',
      pageId: 'actualBillList',
      pageName: '收入列表',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/actualBillList'], resolve),
  },
  {
    path: '/operation/businessManage/invoiceList',
    name: 'operation_invoiceList',
    meta: {
      title: '发票列表',
      pageId: 'invoiceList',
      pageName: '发票列表',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/invoiceList'], resolve),
  },
  {
    path: '/operation/businessManage/receiveList',
    name: 'operation_receiveList',
    meta: {
      title: '流水列表',
      pageId: 'receiveList',
      pageName: '流水列表',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/receiveList'], resolve),
  },
  {
    path: '/operation/businessManage/walletRecharge',
    name: 'operation_walletRecharge',
    meta: {
      title: '钱包充值',
      pageId: 'walletRecharge',
      pageName: '钱包充值',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/walletRecharge'], resolve),
  },
  {
    path: '/operation/businessManage/virtualNumber',
    name: 'operation_virtualNumber',
    meta: {
      title: '银行虚拟号配置',
      pageId: 'virtualNumber',
      pageName: '银行虚拟号配置',
      parentId: 'businessManage',
      parentName: '商务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/businessManage/virtualNumber'], resolve),
  },
  /***********推荐任务************/
  {
    path: '/operation/recommendTask/recommendTaskList',
    name: 'operation_recommendTaskList',
    meta: {
      title: '任务列表',
      pageId: 'recommendTaskList',
      pageName: '推荐任务列表',
      parentId: 'recommendTask',
      parentName: '推荐任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/recommendTask/recommendTaskList'], resolve),
  },
  {
    path: '/operation/recommendTask/recommendBill',
    name: 'operation_recommendBill',
    meta: {
      title: '推荐单据',
      pageId: 'recommendBill',
      pageName: '推荐单据',
      parentId: 'recommendTask',
      parentName: '推荐任务',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/recommendTask/recommendBill'], resolve),
  },
  /***********反馈管理************/
  {
    path: '/operation/feedbackManage/creditScoreApply',
    name: 'operation_creditScoreApply',
    meta: {
      title: '信用分申诉',
      pageId: 'creditScoreApply',
      pageName: '信用分申诉',
      parentId: 'feedbackManage',
      parentName: '反馈管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/feedbackManage/creditScoreApply'], resolve),
  },
  /***********兼职管理************/
  {
    path: '/operation/concurrentPost/staffManage',
    name: 'operation_staffManage',
    meta: {
      title: '人员管理',
      pageId: 'staffManage',
      pageName: '人员管理',
      parentId: 'concurrentPost',
      parentName: '兼职管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/concurrentPost/staffManage'], resolve),
  },
  {
    path: '/operation/concurrentPost/salarySettlement',
    name: 'operation_salarySettlement',
    meta: {
      title: '薪资结算',
      pageId: 'salarySettlement',
      pageName: '薪资结算',
      parentId: 'concurrentPost',
      parentName: '兼职管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/concurrentPost/salarySettlement'], resolve),
  },
  {
    path: '/operation/concurrentPost/partTimeExpenses',
    name: 'operation_partTimeExpenses',
    meta: {
      title: '兼职费用',
      pageId: 'partTimeExpenses',
      pageName: '兼职费用',
      parentId: 'concurrentPost',
      parentName: '兼职管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/concurrentPost/partTimeExpenses'], resolve),
  },
  /***********财务管理************/
  // {
  //   path: '/operation/financeManage/payCSettlement',
  //   name: 'operation_payCSettlement',
  //   meta: {
  //     title: 'C端结算',
  //     pageId: 'payCSettlement',
  //     pageName: 'C端结算',
  //     parentId: 'financeManage',
  //     parentName: '财务管理',
  //     pageLayer: 3,
  //   },
  //   component: resolve => require(['@/views/operation/financeManage/payCSettlement'], resolve),
  // },
  {
    path: '/operation/financeManage/payCCostSheet',
    name: 'operation_payCCostSheet',
    meta: {
      title: 'C端成本单',
      pageId: 'payCCostSheet',
      pageName: 'C端成本单',
      parentId: 'financeManage',
      parentName: '财务管理',
      pageLayer: 3,
    },
    component: resolve => require(['@/views/operation/financeManage/payCCostSheet'], resolve),
  },
];
